import { AbilityContext } from "components/Permissions/Can";
import { useContext, useMemo } from "react";
import { tableHooks } from "components/Table";
import AvatarCell from "pages/School/TestTakers/AvatarCell"

const useColumns = () => {
    const testTakerNameCell = tableHooks.useTestTakerNameCell()
    const idCell = tableHooks.useIdCell()

    const columns = useMemo(
        () => [
            {
                ...idCell,
                accessorKey: "test_taker_id"
            },
            {
                accessorKey: 'img',
                width: 30,
                header: "",
                cell: AvatarCell,
                meta: {
                    label: "פרופיל"
                }
            },
            testTakerNameCell,
            {
                accessorKey: 'tz',
                header: "תעודת זהות",
            },
            {
                accessorKey: 'affiliation_name',
                header: "בית ספר",
                showBrokenDisplay: true
            },
            {
                accessorKey: 'grade_at_registration_name',
                header: "שכבה בעת ההרשמה",
            },
            {
                accessorKey: 'grade_name',
                header: "שכבה נכחית",
            },
            {
                accessorKey: 'school_class_name',
                header: "כיתה",
            },
        ], []
    )

    return columns
}


export default useColumns